export var shouldDisplayImageThumbnail = function (dataURI, mediaType) {
    return !!(mediaType !== 'doc' && dataURI);
};
//# sourceMappingURL=shouldDisplayImageThumbnail.js.map